import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { GET_ASSET_FLEET_LINK_ATTACHMENT_SAVE } from 'Store/FleetManagement/AssetFleetProcessingLinkAttachment/AssetFleetProcessingLinkAttachmentType';
import { setAssetFleetLinkAttachmentSave } from 'Store/FleetManagement/AssetFleetProcessingLinkAttachment/AssetFleetProcessingLinkAttachmentAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* saveAssetFleetLinkAttachment(req: any): any {
    try {
        yield put(globalLoaderText("Saving Linked attachments...."));

        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `asset/fleet/update/attachments`,
            apiMethod: apiMethod.POST,
            payload: req?.attachment

        }
        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setAssetFleetLinkAttachmentSave(response))
            yield put(globalLoaderText(""));
        } else {
            yield put(setAssetFleetLinkAttachmentSave(false))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setAssetFleetLinkAttachmentSave(false))
        yield put(globalLoaderText(""));
    }
}

function* watchGetFleetDispositionPaymentSave() {
    yield takeEvery(GET_ASSET_FLEET_LINK_ATTACHMENT_SAVE, saveAssetFleetLinkAttachment)
}

export default function* combinedSaga() {
    yield all([
        watchGetFleetDispositionPaymentSave()
    ])
}